import { render, staticRenderFns } from "./VIcons.vue?vue&type=template&id=b2428ed8&scoped=true&"
import script from "./VIcons.vue?vue&type=script&lang=js&"
export * from "./VIcons.vue?vue&type=script&lang=js&"
import style0 from "./VIcons.vue?vue&type=style&index=0&id=b2428ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2428ed8",
  null
  
)

export default component.exports